import * as React from 'react'
import { Table, Button, Space, Row, Col, Modal, Input } from 'antd'
import moment from 'moment'
import { StressTestRettificaModel, StressTestRow } from '../../models/StressTestModels'
import { CellLink } from '../CellLink'
import { EditOutlined, PlusCircleOutlined, ReadOutlined, SearchOutlined } from '@ant-design/icons'
import { ModalRettifica } from './ModalRettifica'
import { IStresstestService } from '../../services/StresstestService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import { formatEuro } from '../shared/CurrencyFormat'

const { Column, ColumnGroup } = Table

interface TableStresstestProps {
    mese: number
    dataSource: Array<StressTestRow>
    titolo: string
    result: boolean
    editable: boolean
    filtrable:boolean
    onCellClick?: (data: StressTestRow, rowIndex: number, monthIndex: number) => void
    onReload?: () => void
    StressTestId: string
}

class TableStresstestState {
    MesiColumn: Array<string>
    ModalRettifica: boolean = false
    RettificaId?: string
    StressTestDetailId: string
    ModalMonthIndex: number
    Rettifiche: { [key: string]: Array<StressTestRow> } = {}
}

export class TableStresstest extends React.Component<TableStresstestProps, TableStresstestState> {
    service: IStresstestService

    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.STRESSTEST_SERVICE)
        let state = new TableStresstestState()
        state.MesiColumn = this.calcMonths(moment().month())
        this.state = state
    }

    componentDidUpdate(prevProps: TableStresstestProps, prevState: TableStresstestState) {
        if (prevProps.mese != this.props.mese && this.props.mese != null) {
            let mesiColumn = this.calcMonths(this.props.mese)
            this.setState({ MesiColumn: mesiColumn })
        }
    }

    static defaultProps = {
        mese: moment().month(),
        titolo: "",
        editable: false,
        result: false
    }

    calcMonths = (startMonth: number) => {
        let mesi: Array<string> = []
        for (let i = 0; i < 12; i++) {
            mesi.push(this.getMonthName(startMonth, i))
        }

        return mesi
    }

    getMonthName(startMonth: number, increment: number) {
        return moment().month(startMonth + increment).format("MMMM")
    }

    onCellClick = (data, rowIndex, monthIndex) => {
        debugger
        if (this.props.editable == true && this.props.onCellClick != null)
            this.props.onCellClick(data, rowIndex, monthIndex)
    }


    onCellRettifica = (data, rowIndex, monthIndex) => {
        this.openRettificaModal(data, monthIndex)
    }

    openRettificaModal = (data?: StressTestRow, monthIndex?: number) => {
        let model = this.state
        let stressTestDetailId = data == null ? null : data.Id
        this.setState({ ...model, ModalRettifica: true, RettificaId: null, StressTestDetailId: stressTestDetailId, ModalMonthIndex: monthIndex })
    }

    onEditRettifica = (id: string, parentId: string, monthIndex: number) => {
        let model = this.state
        this.setState({ ...model, ModalRettifica: true, StressTestDetailId: parentId, RettificaId: id, ModalMonthIndex: monthIndex })
    }

    closeRettificaModal = (reload: boolean) => {
        let model = this.state
        this.setState({ ...model, ModalRettifica: false })
        if (reload === true) {
            this.props.onReload()
        }
    }

    renderCell = (value: number, record, rowIndex, monthIndex, isRettifica: boolean) => {
        let val = value == null ? formatEuro(0) : formatEuro(value)
        let color = this.props.result === false ? 'black' : value < 0 ? 'red' : 'green';

        return <Space size="middle">
            {isRettifica || (!isRettifica && this.props.editable === false) ?
                <b><p style={{ color: color }}>{val}</p></b> :
                <b><u><a onClick={() => this.onCellClick(record, rowIndex, monthIndex)} style={{ color: color }}  >{val}</a></u></b>
            }

            {!isRettifica && this.props.editable === false && this.props.result === false ?
                <Button type="text" danger key="edit-lookup-cc" icon={<PlusCircleOutlined />} size="small" onClick={() => this.onCellRettifica(record, rowIndex, monthIndex)} />
                : <></>}

        </Space>
    }

    renderMonthColumns = () => {
        let col = []
        for (let i = 0; i < 12; i++)
            col.push(
                <Column title={this.state.MesiColumn[i]} key={`col${i}`} 
                    render={(value: StressTestRow, record, rowIndex) => this.renderCell(value.Valori[i], record, rowIndex, i, value.IsRettifica)}
                />
            )

        return col
    }

    onDeleteRettifica = (id: string, parentId: string) => {
        Modal.confirm({
            title: "Elimina",
            content: "Eliminare la rettifica?",
            onOk: async () => {
                let resp = await this.service.DeleteRettifica(id, this.props.StressTestId)
                if (resp.IsValid === true) {
                    this.props.onReload()
                }

            }
        })
    }


    renderRettificaNote = (record: StressTestRow, monthIndex: number) => {
        if (record.IsRettifica) {
            return <Space size="large">
                {record.Descrizione}

                <a onClick={() => this.onEditRettifica(record.Id, record.ParentId, monthIndex)}>Modifica</a>
                <a onClick={() => this.onDeleteRettifica(record.Id, record.ParentId)}>Elimina</a>
            </Space>
        }
        else {
            return <Space size="large">
                {record.Descrizione}
            </Space>
        }
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input

                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Cerca
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Resetta
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                        }}
                    >
                        Filtra
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#f5222d' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
    };

    handleReset = clearFilters => {
        clearFilters();
    };

    render() {
        return (
            <>
                <Table
                    dataSource={this.props.dataSource}
                    rowKey={it => it.Id}
                    bordered={true}
                    scroll={{ x: true }}
                    pagination={false}
                >
                    {this.props.filtrable ?
                        <Column title={this.props.titolo} dataIndex="Descrizione" fixed={true}
                            render={(value: string, record: StressTestRow, rowIndex: number) => this.renderRettificaNote(record, rowIndex)}
                            {...this.getColumnSearchProps('Descrizione')}
                        /> :
                        <Column title={this.props.titolo} dataIndex="Descrizione" fixed={true}
                            render={(value: string, record: StressTestRow, rowIndex: number) => this.renderRettificaNote(record, rowIndex)}
                        />
}
                    <ColumnGroup title="Prossimi mesi">
                        {this.renderMonthColumns()}
                    </ColumnGroup>
                </Table>

                {this.state.ModalRettifica ?
                    <ModalRettifica
                        StressTestId={this.props.StressTestId}
                        visible={this.state.ModalRettifica}
                        stressTestDetailId={this.state.StressTestDetailId} monthIndex={this.state.ModalMonthIndex}
                        closeModal={() => this.closeRettificaModal(false)}
                        do={() => this.closeRettificaModal(true)} rettificalId={this.state.RettificaId}
                    /> : <></>
                }
            </>
        )
    }
}